import { render, staticRenderFns } from "./ModalProgress.vue?vue&type=template&id=5206d0fa&"
import script from "./ModalProgress.vue?vue&type=script&lang=js&"
export * from "./ModalProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports